import {AppRegistry} from 'react-native';
import App from './App';

AppRegistry.registerComponent('App', () => App);
AppRegistry.runApplication('App', {rootTag: document.getElementById('root')});

window.onbeforeunload = () => {
  localStorage.clear();
}

window.addEventListener('load', () => {
  localStorage.clear();
})